import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconCheckmarkRoundedFilled = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M29.333 16c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.637 2.667 16 2.667 29.333 8.636 29.333 16m-9.83-4.89a1 1 0 1 1 1.661 1.113l-6.25 9.333a1 1 0 0 1-1.54.15l-3.749-3.77a1 1 0 1 1 1.417-1.41l2.889 2.904z" clipRule="evenodd" /></svg>;
export default SvgIconCheckmarkRoundedFilled;